import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { useScreenInit } from './useScreenInit';
function AppContent() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-arena font-body text-carbon" data-id="element-0" data-mp="3fbjar2g4druw">
      <Header data-id="element-1" data-mp="2rkdy0w5h7fot" />
      <main className="flex-grow" data-id="element-2" data-mp="2rlyr0hc56qkk">
        <Routes data-id="element-3" data-mp="2rl6xrd60p4xg">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mmcde6sej8b8" />} data-id="element-4" data-mp="2riklx1c3g39f" />
          <Route path="/diagnostico" element={<Navigate to="/" replace data-id="element-7" data-mp="2mjpvbd7vxaer" />} data-id="element-6" data-mp="2mmvjmq8ow89f" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-9" data-mp="31brzh9gzmpkl" />} data-id="element-8" data-mp="31b8jvzet8d9q" />
        </Routes>
      </main>
      <Footer data-id="element-10" data-mp="2wk9y4kb1ymz3" />
    </div>;
}
export function App() {
  return <Router data-id="element-11" data-mp="2whxbhtucnofp">
      <AppContent data-id="element-12" data-mp="28ufpkexrnkkn" />
    </Router>;
}